import React from "react";
import { ArrowLeft, ArrowRight } from "lucide-react";
import { Button } from "../ui/button";

const PAGE_SIZE = 12;

const Pagination = ({ page, setPage, gigsLength }) => {
  return (
    <div className="mt-10 flex flex-col gap-3 items-center justify-between border-t border-[#2A2A2A] pt-6 sm:flex-row">
      <Button
        variant="outline"
        onClick={() => setPage((prev) => Math.max(prev - 1, 0))}
        disabled={page === 0}
        className="flex items-center gap-2 px-4 py-3 text-sm text-white border-[#2A2A2A] hover:bg-[#1A1A1A]"
      >
        <ArrowLeft className="w-4 h-4" />
        Previous
      </Button>
      <span className="text-sm text-zinc-400">Pagina {page + 1}</span>
      <Button
        variant="outline"
        onClick={() => setPage((prev) => prev + 1)}
        disabled={gigsLength < PAGE_SIZE}
        className="flex items-center gap-2 px-4 py-3 text-sm text-white border-[#2A2A2A] hover:bg-[#1A1A1A]"
      >
        Next
        <ArrowRight className="w-4 h-4" />
      </Button>
    </div>
  );
};

export default Pagination;
